import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ExcelExportService } from "src/app/services/excel-export.service";
import { ReportService } from "src/app/services/report.service";
import { DEPENDENCY_FIELDS, REPORT_DEPENDENCIES } from "./report-dependencies";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";

@Component({
  selector: "app-secure-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
})
export class ReportsComponent implements OnInit {
  
  isLoading = false;
  multiSelectedLottery= []
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  private boardsListFetched: boolean = false; // Initialize the flag
  private lotteryeventsListFetched: boolean = false; // Initialize the flag
  boardKey: number;

  lotteryList: {[key: number]: string};
  boardsList: {[key: number]: string};
  reports: {[key: string]: {[key: string]: string}};
  LotteryEventList: {[key: number]: string};
  LotterysList: {[key: number]: string};
  selectedBoard :any
  showYearDropdown: boolean = false;
  years: number[] = [2022, 2023, 2024, 2025, 2026];
  selectedYear:string;

  constructor(
    private router: Router,
    private reportService: ReportService,
    private excelExportService: ExcelExportService
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.form = new FormGroup({
      selectedReport: new FormControl("", Validators.required),
      selectedBoard: new FormControl(),
      selectedLotteryEventId: new FormControl(),
      selectedYear: new FormControl(),
    });
    // this.fetchBoardsList();
  }

  loadData() {
    this.isLoading = true;
    this.reportService.initReportForm()
    .subscribe((data) => {
      this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.lotteryList = data.lotteryList;
          this.reports = data.reports;
        }
        else {
          this.reportService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.reportService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      if(this.form.value.selectedReport.key.indexOf('JASPER') >= 0) {
        console.log("this.form.value.selectedReport",this.form.value.selectedReport);
        if(this.form.value.selectedReport.value.reportName == 'Mumbai_Payment_Settlment'){
          this.reportService.generateReportWithStartDateAndEndDate(+this.form.value.selectedReport.key.replace('JASPER', ''), {
            boardKey: this.form.value.boardKey.key,
            settlmentStartDate: this.form.value.settlmentStartDate,
            settlmentEndDate: this.form.value.settlmentEndDate,
          })
          .subscribe((data) => {
            this.isSubmitDisabled = false;
            this.isLoading = false;
            if(data.status === 'SUCCESS') {
              this.downloadFile(data.base64File, data.fileName);
            }
            else {
              this.reportService.errorToast(data.errorMessage);  
            }
          }, error => {
            this.isLoading = false;
            this.isSubmitDisabled = false;
            this.reportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
          });

        }
        else{
        this.reportService.generateReport(+this.form.value.selectedReport.key.replace('JASPER', ''), {
          lotteryKey: this.form.value.lotteryKey?.key
        })
        .subscribe((data) => {
          this.isSubmitDisabled = false;
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.downloadFile(data.base64File, data.fileName);
          }
          else {
            this.reportService.errorToast(data.errorMessage);  
          }
        }, error => {
          this.isLoading = false;
          this.isSubmitDisabled = false;
          this.reportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        });
      }
      }
      else if(this.form.value.selectedReport.key.indexOf('QUERY') >= 0) {
        const selectedLotteryValue = this.form.get('selectedLotteryEventId')?.value;

        this.multiSelectedLottery = selectedLotteryValue ? selectedLotteryValue.map(r => r.key) : null;

        const selectedBoardValue =this.form.get('selectedBoard')?.value
        this.boardKey=selectedBoardValue?selectedBoardValue.key:null
        
        // if(  this.multiSelectedLottery ===null &&  this.boardKey===null){
        //          //regular
        // }else if(this.multiSelectedLottery !==null &&  this.boardKey!==null){
        //      // Call both parameter api
        // }
        //   else if(this.boardKey !== null)
        // {
        //   // call Board Api
        // }else if(this.multiSelectedLottery !==null){
        //   //call Lottery api
        // }

        this.reportService.fetchQueryExecutorReport(+this.form.value.selectedReport.key.replace('QUERY', ''), this.boardKey,this.multiSelectedLottery)
        .subscribe((data) => {
          this.isSubmitDisabled = false;
          this.isLoading = false;
          
          // console.log("data.selectedBoardDetail",data.selectedBoardDetail);
          // console.log("data.selectedLotteryEventDetails",data.selectedLotteryEventDetails);//selectedBoardDetail
          // console.log("this.dynamicParameters",data.dynamicParameter);

          if(data.status === 'SUCCESS') {
            //if((data.selectedBoardDetail ===null || data.selectedLotteryEventDetails === null) && (data.dynamicParameters === null || data.dynamicParameters === "")){//this.selectedBoard.dynamicParameters ===null
            if ((data.selectedBoardDetail === null || data.selectedLotteryEventDetails === null) && (data.dynamicParameter === null || data.dynamicParameter === "")) {
              this.excelExportService.exportExcel(data.title, data.columnNames, 
                data.lst, data.columnWidths, 
                data.generatedBy, data.generatedOn,
                );
              }
              //if dynamic data is present
              if((data.selectedBoardDetail!=null || data.selectedLotteryEventDetails!=null) && (data.dynamicParameter != null)){//this.selectedBoard.dynamicParameters !==null
                if(this.boardKey !=null || this.multiSelectedLottery !=null){
                  this.excelExportService.exportExcelForDynamic(data.title, data.columnNames, 
                    data.lst, data.columnWidths, 
                    data.generatedBy, data.generatedOn,data.selectedBoardDetail,data.selectedLotteryEventDetails
                    );
                }
              }
          }
          else {
            this.reportService.errorToast(data.errorMessage);  
          }
        }, error => {
          this.isLoading = false;
          this.isSubmitDisabled = false;
          this.reportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        });
      }
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  addDependency(e: any) {
    this.form.controls.selectedBoard.setValue(null); // Set selectedBoard to null
    this.form.controls.selectedLotteryEventId.setValue(null); // Set selectedLotteryEventId to null
    this.form.controls.selectedYear.setValue(null); // Set selectedYear to null
    Object.keys(DEPENDENCY_FIELDS).forEach(o => {
      this.form.removeControl(o);
    });
    this.showYearDropdown = false; // Reset to false initially
    
    if(e !== '') {
      REPORT_DEPENDENCIES[e.value.reportName]?.forEach(o => {
        this.form.addControl(o, new FormControl("", Validators.required));
      })
      if (e.value.dynamicParameters && e.value.dynamicParameters.includes("lotteryEventIds")) {
        this.showYearDropdown = true;
    } else {
        this.showYearDropdown = false;
    }
      this.shouldShowDiv()
      this.shouldShowLottery()
    }
  }

  shouldShowDiv(): boolean {
    const selectedBoard = this.form.get('selectedReport')?.value?.value;
    this.selectedBoard=selectedBoard;
    // console.log("atmadhali value shouldShowDiv()",selectedBoard);
    
    if (!this.boardsListFetched) { // Check if the API has not been called yet
      this.fetchBoardsList(); // Call the API when dynamicParameters include 'BoardId'
      this.boardsListFetched = true; // Set the flag to true to indicate that the API has been called
  }

    if (selectedBoard && selectedBoard.dynamicParameters && selectedBoard.dynamicParameters.includes('boardId')) {
      if (!this.boardsListFetched) { // Check if the API has not been called yet
          this.fetchBoardsList(); // Call the API when dynamicParameters include 'BoardId'
          this.boardsListFetched = true; // Set the flag to true to indicate that the API has been called
      }
      return true; // Show the div
  }else {
      return false; // Hide the div
  }
  }

  shouldShowLottery(): boolean {
    const selectedBoard = this.form.get('selectedReport')?.value?.value;
    this.selectedBoard=selectedBoard;
    //console.log("atmadhali vlaue shouldShowLottery()",this.selectedBoard);
    if (selectedBoard && selectedBoard.dynamicParameters && selectedBoard.dynamicParameters.includes('lotteryEventIds')) {
      if (!this.lotteryeventsListFetched) { 
          this.lotteryeventsListFetched = true; 
          //this.fetchLotteryList()
        }
      return true; 
  }else {
      return false; 
  }
  }

  showBoard(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  showLottery(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  fetchBoardsList(): void {
    this.reportService.getBoardsList().subscribe((data: any) => {
      this.boardsList = data.boards; // Assign the fetched data to boardsList
    });
 }

  onBoardChange(selectedValue: any) {
    this.form.controls.selectedLotteryEventId.setValue(null); // Set selectedLotteryEventId to null
    this.form.controls.selectedYear.setValue(null); // Set selectedYear to null
    this.boardKey=selectedValue.key
    // this.reportService.getLotteryList(selectedValue.key).subscribe((selectedValue:any) => {
    //   this.LotteryEventList = selectedValue.lotterylist; 
    // });
  }

  fetchLotteryList(selectedYear): void {
    console.log("yeudet hit",this.boardKey);
    
    this.reportService.fetchLotteryList(selectedYear,this.boardKey).subscribe((data: any) => {
      this.LotteryEventList = data.lotterylist; // Assign the fetched data to boardsList
    });
 }
 onYearChange(selectedYear: any) {
  this.form.controls.selectedLotteryEventId.setValue(null); // Set selectedLotteryEventId to null
  this.selectedYear=selectedYear
  //this.reportService.getLotteryList(this.selectedYear).subscribe((selectedYear:any) => {
   // this.LotteryEventList = selectedYear.lotterylist; 
    this.fetchLotteryList(this.selectedYear);
  //});
}
}